import { LOGIN_MSG } from '@whistler-ui/k2/constants/appMessages';

import { AuthService } from '../services/authService';
import { getAccessTokenExpiry } from '../services/authSession';
import { signOut } from '../services/helper';
import { logger } from './common';

const signOutLog = async () => {
  logger('Singing out, you session is expired');
  await signOut({ appMsg: LOGIN_MSG.SESSION_EXPIRED });
};

const isExpired = exp => {
  const nowInSeconds = Math.floor(Date.now() / 1000);
  return exp < nowInSeconds;
};

const getTimeDiff = exp => exp * 1000 - Date.now();

let _timeout = 0;

function validateExp() {
  AuthService.currentSession()
    .then(session => {
      const exp = getAccessTokenExpiry(session);

      if (isExpired(exp)) {
        return signOutLog();
      }

      if (_timeout === 0) {
        _timeout = getTimeDiff(exp);
        window.setTimeout(signOutLog, _timeout);
      }
    })
    .catch(signOutLog);
}

/**
 * Singleton
 * 1. On focus/blur validate cognito's session and accessToken expiry
 * 2. Automatically sign out user when expiry is up
 */
export const sessionTracker = (function () {
  let instance = null;

  function Main() {
    window.addEventListener('blur', validateExp, true);
    window.addEventListener('focus', validateExp, true);
    validateExp();

    logger('Your session is being tracked.');
  }

  return {
    start: function () {
      if (!instance) {
        instance = new Main();
        delete instance.constructor;
      }

      return instance;
    },
  };
})();
